module.exports = __webpack_public_path__ + "static/empty-states-cta-dont-706d7c6355cb31389e2a94311121d608.png";